export enum HaulRoadLayerTypeResponse {
  CenterLine = 'center_line',
  Edges = 'edges',
  Medians = 'medians',
  GradientAnalysis = 'gradient_analysis',
  WidthAnalysis = 'width_analysis',
  BermAnalysis = 'berm_analysis',
}

export enum HaulRoadLayerType {
  CenterLine = 'centerLine',
  Edges = 'edges',
  Medians = 'medians',
  GradientAnalysis = 'gradientAnalysis',
  WidthAnalysis = 'widthAnalysis',
  BermAnalysis = 'bermAnalysis',
}
